import { createNamedContext } from '@utils';
import * as I from './interfaces';

export const CompanyOverviewContext = createNamedContext<I.CompanyOverviewContextValue>(undefined, 'Company.Overview.Context');
export const CompanyCurrentEmployeesContext = createNamedContext<I.CompanyCurrentEmployeesContextValue>(undefined, 'Company.CurrentEmployees.Context');
export const CompanyFormerEmployeesContext = createNamedContext<I.CompanyFormerEmployeesContextValue>(undefined, 'Company.FormerEmployees.Context');